module.exports = __webpack_public_path__ + "static/media/analysis.21812965.svg";